import React from "react";
import { connect } from "react-redux";
import { fetchAccounts } from "../../queries/bank/accountsQuery";
import language from "../../language";
import NewAccount from "./NewAccount";
import handleSearch from "../../utils/handleSearch";
import { Table } from "../Table";
import { Modal } from "../Modal";
import icons from "../../constants/icons";

let copyData = [];

class Accounts extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage, active } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchAccounts(defaultLanguage, { active });

      this.setState({
        isLoading: false,
        data,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].account_name,
        key: "accountName",
        type: "link",
        onPress: (item) =>
          (window.location.href =
            "/merchant/account/charges?accountId=" +
            item.accountId +
            "&accountName=" +
            item.accountName),
      },
      {
        title: language[this.props.defaultLanguage].bank,
        key: "name",
      },
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
      },
      {
        title: language[this.props.defaultLanguage].account_type,
        key: "accountType",
      },
      {
        title: language[this.props.defaultLanguage].account_number,
        key: "accountNumber",
      },
      {
        title: language[this.props.defaultLanguage].active,
        key: "active",
      },
      {
        title: language[this.props.defaultLanguage].approved,
        key: "approved",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: language[this.props.defaultLanguage].view,
            onPress: (item) =>
              (window.location.href =
                "/merchant/account/charges?accountId=" +
                item.accountId +
                "&accountName=" +
                item.accountName),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].add_account}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].account
          )}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e.target.value })
          }
          rowPress={(item) =>
            (window.location.href =
              "/merchant/account/charges?accountId=" +
              item.accountId +
              "&accountName=" +
              item.accountName)
          }
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewAccount
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Accounts);
